import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";

export interface ISplitRowProps extends React.HTMLAttributes<HTMLDivElement> {
    left: React.ReactNode;
    right: React.ReactNode;
    wrap?: boolean;
}

export const SplitRow: React.FC<ISplitRowProps> = ({ left, right, wrap, className, ...rest }) => {
    return (
        <BTRow
            align="middle"
            responsiveMode="viewport"
            className={className}
            gutter={16}
            justify="space-between"
            wrap={wrap}
            {...rest}
        >
            <BTCol flex="auto">
                <BTRow responsiveMode="viewport" wrap={false} align="middle">
                    {left}
                </BTRow>
            </BTCol>
            <BTCol>
                <BTRow responsiveMode="viewport" wrap={false} align="middle">
                    {right}
                </BTRow>
            </BTCol>
        </BTRow>
    );
};

export default SplitRow;
